import { useState, useEffect } from 'react';
import { DJProfile } from '../../../lib/supabase';

interface NavbarProps {
  profile: DJProfile | null;
  imageVersion?: number;
}

export default function Navbar({ profile }: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const logoUrl = (profile as any)?.logo_url
    ? (profile as any).logo_url
    : `https://wbaggrbegrkcmiahpejw.supabase.co/storage/v1/object/public/Fotos/logo_white_trans.png`;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || isMenuOpen ? 'bg-black/95 backdrop-blur-lg shadow-lg shadow-cyan-500/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <button onClick={() => scrollToSection('hero')} className="cursor-pointer">
            <img
              src={logoUrl}
              alt={profile?.name || 'Miki Buades Logo'}
              className="h-12 w-auto"
            />
          </button>

          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('past-events')} className="text-gray-300 hover:text-cyan-400 transition-colors cursor-pointer whitespace-nowrap">Eventos</button>
            <button onClick={() => scrollToSection('gallery')} className="text-gray-300 hover:text-cyan-400 transition-colors cursor-pointer whitespace-nowrap">Galería</button>
            <button onClick={() => scrollToSection('music')} className="text-gray-300 hover:text-cyan-400 transition-colors cursor-pointer whitespace-nowrap">Música</button>
            <button onClick={() => scrollToSection('upcoming-events')} className="text-gray-300 hover:text-cyan-400 transition-colors cursor-pointer whitespace-nowrap">Próximos</button>
            <button onClick={() => scrollToSection('contact')} className="px-6 py-2 bg-gradient-to-r from-cyan-500 to-fuchsia-500 text-white rounded-full hover:shadow-lg hover:shadow-cyan-500/50 transition-all cursor-pointer whitespace-nowrap">Contacto</button>
          </div>

          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer">
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden mt-4 py-4 border-t border-cyan-500/20">
            <div className="flex flex-col gap-4">
              <button onClick={() => scrollToSection('past-events')} className="text-gray-300 hover:text-cyan-400 transition-colors text-left cursor-pointer whitespace-nowrap">Eventos</button>
              <button onClick={() => scrollToSection('gallery')} className="text-gray-300 hover:text-cyan-400 transition-colors text-left cursor-pointer whitespace-nowrap">Galería</button>
              <button onClick={() => scrollToSection('music')} className="text-gray-300 hover:text-cyan-400 transition-colors text-left cursor-pointer whitespace-nowrap">Música</button>
              <button onClick={() => scrollToSection('upcoming-events')} className="text-gray-300 hover:text-cyan-400 transition-colors text-left cursor-pointer whitespace-nowrap">Eventos</button>
              <button onClick={() => scrollToSection('contact')} className="px-6 py-2 bg-gradient-to-r from-cyan-500 to-fuchsia-500 text-white rounded-full hover:shadow-lg hover:shadow-cyan-500/50 transition-all text-center cursor-pointer whitespace-nowrap">Contacto</button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
